module.exports = __webpack_public_path__ + "img/rt.36795039.svg";